export class UserModel {
    constructor (
        public user: string,
        public password: string
    ) {}
}
